import InfoOutlined from '@mui/icons-material/InfoOutlined';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { OperatorChip, OperatorType } from '../DimensionChip/OperatorChip';
import ConjunctionIcon from './assets/conjunction.svg?react';
import DisjunctionIcon from './assets/disjunction.svg?react';
import NegationIcon from './assets/negation.svg?react';

export const Legend = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <InfoOutlined sx={{ color: 'text.secondary', fontSize: 15 }} />
          <Typography
            variant="body1Bold"
            component="span"
            sx={{
              pl: 1,
            }}
          >
            {t('Understanding Logical Operators')}
          </Typography>
        </Box>

        <Button onClick={() => setShow(prev => !prev)} aria-expanded={show}>
          {show ? t('Hide') : t('Show')}
        </Button>
      </Box>
      <Collapse in={show} timeout="auto" unmountOnExit>
        <Box
          sx={{
            mt: 2,
          }}
        >
          <OperatorChip operator={OperatorType.AND} readonly hideDivider />
        </Box>

        <Grid
          container
          sx={{
            mt: 1,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Grid size={8}>
            <Typography variant="body2" sx={{ '& b': { fontWeight: 700 } }}>
              <Trans i18nKey="legend_and">
                User must meet <b>all</b> selected conditions. Use to narrow your audience.
              </Trans>
            </Typography>
          </Grid>
          <Grid size={4} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <ConjunctionIcon />
          </Grid>
        </Grid>

        <Box
          sx={{
            mt: 3,
          }}
        >
          <OperatorChip operator={OperatorType.OR} readonly hideDivider />
        </Box>

        <Grid
          container
          sx={{
            mt: 1,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Grid size={8}>
            <Typography variant="body2">
              <Trans i18nKey="legend_or" sx={{ '& b': { fontWeight: 700 } }}>
                User must meet <b>at least one</b> condition. Good for reaching more people.
              </Trans>
            </Typography>
          </Grid>
          <Grid size={4} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <DisjunctionIcon />
          </Grid>
        </Grid>

        <Box
          sx={{
            mt: 3,
          }}
        >
          <OperatorChip operator={OperatorType.EXCLUDE} readonly hideDivider />
        </Box>

        <Grid
          container
          sx={{
            mt: 1,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Grid size={8}>
            <Typography variant="body2" sx={{ '& b': { fontWeight: 700 } }}>
              <Trans i18nKey="legend_excludes">
                <b>Excludes</b> items that match the condition. Use this to filter out unwanted results.
              </Trans>
            </Typography>
          </Grid>
          <Grid size={4} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <NegationIcon />
          </Grid>
        </Grid>
      </Collapse>
    </Box>
  );
};
